import { gql } from '@apollo/client';

export const GET_JOYRIDE = gql`
query Joyride {
  joyride {
    id
    name
    startDate
    endDate
    challenge
    target
  }
}`;
